










































































import {
  defineComponent,
  watch,
  ref,
  reactive,
  computed,
  onMounted,
  nextTick,
  onUnmounted,
  toRefs,
} from '@vue/composition-api';
import lottie from 'lottie-web';
import _ from 'lodash';
import { EllipsisIcon } from 'tdesign-icons-vue';

import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import storage from '@/renderer/scripts/utils/storage';
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import { httpUrl } from '@/renderer/scripts/http';
import i18n, { i18n_t } from '@/locales/i18n';
import { IS_PRIVATE } from '@/common/constant';
import guideStepHandler from '../composition/guideStepHandler';

type SpaceGuides = {
  id: number;
  title: string;
  text: string;
  done?: boolean;
};
export default defineComponent({
  props: {
    toggleGuide: {
      type: Boolean,
      default: true,
    },
    guideUnFinished: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EllipsisIcon,
  },
  setup(props, context) {
    const store = context.root.$store;
    const routerName = ref(context.root.$route.name);
    const activeIndex = ref(1);
    const expansionWidth = '566px';
    const expansionHeight = '258px';
    const collapseWidth = '260px';
    const collapseHeight = '72px';

    const { toggleGuide, guideUnFinished } = toRefs(props);

    // 是否显示pop
    const showPopConfirm = ref(false);
    const initStyle = reactive({
      width: collapseWidth,
      height: collapseHeight,
    });
    const baseAnimationUrl = `${httpUrl.staticCDNUrl}/tools/images/guideAnimation/`;
    const animationPath = ref('');
    const personalSpaceGuides = ref([
      {
        id: 1,
        title: i18n_t('上传一份文件'),
        text: i18n_t('点击上传按钮/拖拽文件都可以上传'),
        done: !!store.getters.noviceGuidance?.baseGuide?.personalSpace?.steps[0],
      },
      {
        id: 2,
        title: i18n_t('打开查看一份文件'),
        text: IS_PRIVATE ? i18n_t('文档、图片和音视频均可在线预览') : i18n_t('可打开查看《轻松提升办公技能》'),
        done: !!store.getters.noviceGuidance?.baseGuide?.personalSpace?.steps[1],
      },
      {
        id: 3,
        title: i18n_t('分享一份文件'),
        text: i18n_t('遇到很棒的文件，试试分享给好友'),
        done: !!store.getters.noviceGuidance?.baseGuide?.personalSpace?.steps[2],
      },
    ]);
    const collaborationSpaceGuides = ref([
      {
        id: 1,
        title: i18n_t('新建一个协作群组'),
        text: i18n_t('点击新建协作按钮即可创建'),
        done: !!store.getters.noviceGuidance?.baseGuide?.collaborationSpace?.steps[0],
      },
      {
        id: 2,
        title: i18n_t('邀请群组成员加入'),
        text: i18n_t('邀请同事或伙伴加入，一起协同创作'),
        done: !!store.getters.noviceGuidance?.baseGuide?.collaborationSpace?.steps[1],
      },
    ]);
    let guideAnimation: any = null;
    const guideShow = computed(() => {
      const { isMobile, isMobileStyle, userBaseInfo } = store.getters;
      const { isTemporary } = userBaseInfo;
      if (isMobile || isMobileStyle || isTemporary) return false;
      const baseGuideDone = store.getters.noviceGuidance?.baseGuide?.done;
      if (!baseGuideDone && (routerName.value === 'personalSpace' || routerName.value === 'collaborationSpace')) {
        return true;
      }
      return false;
    });
    const { methods: guideStepMethods } = guideStepHandler();
    const spaceGuideLists = computed(() => {
      return routerName.value === 'personalSpace' ? personalSpaceGuides.value : collaborationSpaceGuides.value;
    });

    const methods = {
      handleProcess(step: number) {
        if (routerName.value === 'personalSpace') {
          switch (step) {
            // 上传引导
            case 1: {
              animationPath.value = `${baseAnimationUrl}upload/data.json`;
              ipc.emit(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, 'showUploadGuide');
              reporter.report('upload_guide', { guide_detail: 'click' });
              break;
            }
            // 查看新手指引文件引导
            case 2: {
              animationPath.value = `${baseAnimationUrl}check/data.json`;
              ipc.emit(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, 'showCheckFileGuide');
              reporter.report('check_guide', { guide_detail: 'click' });
              break;
            }
            // 分享文件引导
            case 3: {
              // 需要查看是否关闭了安全外联的功能
              const { enableShare } = store.getters;
              if (!enableShare) {
                tips.error(i18n_t('安全外链空间未开放，请咨询管理员开放后再尝试'));
                return;
              }
              animationPath.value = `${baseAnimationUrl}shareFiles/data.json`;
              ipc.emit(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, 'showShareGuide');
              reporter.report('share_guide', { guide_detail: 'click' });
              break;
            }
            default: {
              animationPath.value = `${baseAnimationUrl}upload/data.json`;
              break;
            }
          }
        } else if (routerName.value === 'collaborationSpace') {
          switch (step) {
            // 创建协作引导
            case 1: {
              animationPath.value = `${baseAnimationUrl}create/data.json`;
              ipc.emit(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, 'showCreateCollaborationGuide');
              reporter.report('createCollaboration', { guide_detail: 'show' });
              break;
            }
            // 协作添加成员引导
            case 2: {
              animationPath.value = `${baseAnimationUrl}invite/data.json`;
              ipc.emit(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, 'showInviteMemberGuide');
              reporter.report('inviteMember_guide', { guide_detail: 'show' });
              break;
            }
            default: {
              break;
            }
          }
        }
      },
      handleFoldGuide(toggle?: boolean) {
        if (typeof toggle !== 'undefined') {
          routerName.value === 'collaborationSpace' && storage.set(storage.StoreKey.PACK_UP_COLL_NOVICE_WORK, toggle);
          routerName.value === 'personalSpace' && storage.set(storage.StoreKey.PACK_UP_PERSONAL_NOVICE_WORK, toggle);
        }
        showPopConfirm.value = false;
        context.emit('action', !toggleGuide.value);
      },
      initAnimation() {
        const animationWrapper: Element = document.querySelector('.guide-step__show-diagram') as Element;
        guideAnimation = lottie.loadAnimation({
          container: animationWrapper,
          // 包含动画的dom元素
          renderer: 'svg',
          // 渲染出来的是什么格式
          loop: true,
          // 循环播放
          autoplay: true,
          // 自动播放
          path: animationPath.value, // 动画json的路径
        });
      },

      onClickProcess: _.throttle((item: SpaceGuides) => {
        showPopConfirm.value = false;
        if (item.done) return;
        activeIndex.value = item.id;
        methods.handleProcess(item.id);
        guideAnimation.destroy();
        methods.initAnimation();
        guideAnimation.play();
      }, 1000),
      continueExplore() {
        const { baseGuide } = store.getters.noviceGuidance;
        if (baseGuide && !baseGuide.collaborationSpace.done) {
          dispatchRouter({
            name: 'collaborationSpace',
          });
        } else {
          dispatchRouter({
            name: 'personalSpace',
          });
        }
      },
      onOperateEventProxy(command: string) {
        switch (command) {
          case 'skip':
            for (let i = 0; i < spaceGuideLists.value.length; i++) {
              const ele = spaceGuideLists.value[i];
              !ele.done && guideStepMethods.monitoringStepsDone(routerName.value as string, ele.id - 1);
            }
            methods.handleFoldGuide();
            showPopConfirm.value = false;
            break;
          default:
            break;
        }
      },
      hidePopupFn(e: MouseEvent) {
        const className = (e?.target as HTMLElement)?.className;
        if (className === 't-button__text') return;
        // 当点击的不是这个元素的时候就隐藏popup
        if (className !== 't-popconfirm__buttons') {
          showPopConfirm.value = false;
        }
      },
    };
    onMounted(() => {
      if (initStyle.width === expansionWidth && guideUnFinished.value) {
        methods.initAnimation();
      }
      document.addEventListener('click', methods.hidePopupFn, false);
    });
    onUnmounted(() => {
      document.removeEventListener('click', methods.hidePopupFn, false);
    });
    watch(initStyle, val => {
      // 再展开后再加载动画，防止动画样式错乱
      if (val.width === expansionWidth && guideAnimation === null) {
        nextTick(() => {
          methods.initAnimation();
        });
      }
    });
    watch(
      () => activeIndex.value,
      val => {
        if (routerName.value === 'personalSpace') {
          // 上传=1、查看=2、分享=3
          const newHandTypeList = ['', 'upload', 'view', 'share'];
          reporter.report('newhand', {
            newhand_task_show: newHandTypeList[val],
          });
        } else if (routerName.value === 'collaborationSpace') {
          // 创建群组=1、邀请加入群组=2
          const newHandTypeList = ['', 'buildgroup', 'invite'];
          reporter.report('newhand', {
            newhand_task_show: newHandTypeList[val],
          });
        }
      },
      {
        immediate: true,
      },
    );

    watch(
      () => toggleGuide.value,
      val => {
        nextTick(() => {
          initStyle.width = val ? expansionWidth : collapseWidth;
          initStyle.height = val ? expansionHeight : collapseHeight;
          methods.initAnimation();
        });
      },
      {
        immediate: true,
      },
    );

    watch(
      () => context.root.$route.name,
      val => {
        const initAnimationUrl =
          val === 'personalSpace' ? `${baseAnimationUrl}upload/data.json` : `${baseAnimationUrl}create/data.json`;
        routerName.value = context.root.$route.name as string;
        nextTick(() => {
          animationPath.value = initAnimationUrl;
          guideAnimation && guideAnimation.destroy();
          methods.initAnimation();
          guideAnimation.play();
        });
      },
      { immediate: true },
    );

    // 需监听新手引导数据及路由的变化
    watch(
      () => [store.getters.noviceGuidance, context.root.$route.name],
      (val: any) => {
        const { baseGuide } = val[0];
        if (!baseGuide) return;
        if (routerName.value === 'personalSpace') {
          baseGuide.personalSpace.steps.forEach((step: number, index: number) => {
            personalSpaceGuides.value[index].done = !!step;
          });
        } else if (routerName.value === 'collaborationSpace') {
          baseGuide.collaborationSpace.steps.forEach((step: number, index: number) => {
            collaborationSpaceGuides.value[index].done = !!step;
          });
        }
      },
    );

    return {
      initStyle,
      guideShow,
      routerName,
      spaceGuideLists,
      showPopConfirm,
      activeIndex,
      ...methods,
      ...guideStepMethods,
    };
  },
});
